import React from "react";
import {Paper, Typography} from "@mui/material";
import {Container} from "@mui/system";
import Box from "@mui/material/Box";

import {BreadcrumbsComponent} from "../../components/UI/breadcrumb/BreadcrumbComponent";
import KuhniHowItWorksSection from "../../components/KuhniHowItWorksSection";

const HowToOrder = () => {
    return (
        <Paper
            sx={{
                width: "100%",
                paddingBottom: "40px",
                display: "flex",
                justifyContent: "space-between",
                flexGrow: 1,
            }}
        >
            <Container
                sx={{
                    "&.MuiContainer-root": {
                        maxWidth: "1668px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "60px",
                    },
                }}
            >
                <Box>
                    <BreadcrumbsComponent
                        page={"Как сделать заказ?"}
                        path={[{name: "Главная", href: "/"}]}
                    />
                </Box>

                <Typography
                    sx={{
                        fontSize: "40px",
                        fontWeight: 700,
                        lineHeight: 1,
                        "@media (max-width: 1450px)": {
                            fontSize: "28px",
                        },
                    }}
                >
                    Как сделать заказ?
                </Typography>

                <KuhniHowItWorksSection/>
            </Container>
        </Paper>
    );
};

export default HowToOrder;

